import { createAction } from '@reduxjs/toolkit';

export const SET_PARAM_QUOTE_DETAIL = 'SET_PARAM_QUOTE_DETAIL';
export const setParamsQuoteDetail = createAction<any>(SET_PARAM_QUOTE_DETAIL);

export const UPDATE_PARAM_QUOTE_DETAIL = 'UPDATE_PARAM_QUOTE_DETAIL';
export const updateParamsQuoteDetail = createAction<any>(UPDATE_PARAM_QUOTE_DETAIL);
